export default "__VITE_PUBLIC_ASSET__880aacd9__"